$(document).ready(function () {
  // Global Variables

  const toggle_primary_button = $(".nav_toggle_button");
  const toggle_primary_icon = $(".nav_toggle_button i");
  const toggle_secondary_button = $(".page_nav li span");
  const primary_menu = $(".page_nav");
  const secondary_menu = $(".page_nav ul ul");

  let webHeight = $(document).height();
  let window_width = $(window).width();

  // Company name and phone number on content area
  $(
    "main * :not('h1'),main p,aside, #banner, #middle, #bottom1, #bottom2, #bottom3, footer p"
  )
    .not(".woocommerce *")
    .each(function () {
      const regex1 =
        /(?![^<]+>)((\+\d{1,2}[\s.-])?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{6})/g;
      const regex2 =
        /(?![^<]+>)((\+\d{1,2}[\s.-])?\(?\d{3}\)?[\s.-]?\d{4}[\s.-]?\d{4})/g;
      const regex =
        /(?![^<]+>)((\+\d{1,2}[\s.-])?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})/g;
      $(this).html(
        $(this)
          .html()
          .replace(/Boulevard Pharmaceutical Compounding Center/g, "<mark class='comp'>$&</mark>")
          .replace(/Boulevard Compounding Pharmacy/g, "<mark class='comp'>$&</mark>")
          .replace(/BPCC/g, "<mark class='comp'>$&</mark>")
          .replace(regex1, "<mark class='main_phone'>$&</mark>")
          .replace(regex2, "<mark class='main_phone'>$&</mark>")
          .replace(regex, "<mark class='main_phone'>$&</mark>")
      );
    });

  $("main a[href]").each(function () {
    const newHref = $(this)
      .attr("href")
      .replace("<mark class='comp'>", "")
      .replace("</mark>", "");
    $(this).attr("href", newHref);
  });

  // Forms on content area
  const form = $("main").find("#myframe");
  if (form.length > 0) {
    document.getElementById("myframe").onload = function () {
      calcHeight();
    };
  }

  // Add class to tab having drop down
  $(".page_nav li:has(ul)").find("span i").addClass("fa-caret-down");

  //Multi-line Tab
  toggle_secondary_button.click(function () {
    $(this)
      .parent("li")
      .siblings("li")
      .children("ul")
      .slideUp(400, function () {
        $(this).removeAttr("style");
      });

    $(this)
      .parent("li")
      .siblings("li")
      .find(".fa")
      .removeClass("fa-caret-up")
      .addClass("fa-caret-down");

    $(this).parent("li").children("ul").slideToggle();
    $(this).children().toggleClass("fa-caret-up").toggleClass("fa-caret-down");
  });

  // Basic functionality for nav_toggle

  const hamburger = $(".hamburger");
  // hamburger.each(function(){
  // $(this).click(function(){
  // $(this).toggleClass("is-active");
  // });
  // });

  hamburger.click(function () {
    primary_menu.addClass("toggle_right_style");
    $(".toggle_right_nav").addClass("toggle_right_cont");
    $(".nav_toggle_button").toggleClass("active");
    $(".hamburger").toggleClass("is-active");
    $("body").addClass("active");
  });

  $(".toggle_nav_close, .menu_slide_right .hamburger").click(function () {
    primary_menu.removeClass("toggle_right_style");
    secondary_menu.removeAttr("style");
    toggle_secondary_button
      .children()
      .removeClass("fa-caret-up")
      .addClass("fa-caret-down");
    $(".toggle_right_nav").removeClass("toggle_right_cont");
    $(".nav_toggle_button").removeClass("active");
    $(".hamburger").removeClass("is-active");
    $("body").removeClass("active");
  });

  // Swap Elements
  function swap_this() {
    if (window_width <= 800) {
      $(".main_logo").insertAfter(".logo_wrap");
      $("#nav_area").insertBefore("#header");
      $(".top_header_social").insertBefore(".header_info");
    } else if (window_width > 800 && window_width <= 1000) {
      $(".main_logo").insertBefore(".head_info");
      $("#nav_area").insertAfter("#header");
      $(".top_header_social").insertBefore(".header_info");
    } else {
      $(".main_logo").insertBefore(".head_info");
      $("#nav_area").insertAfter("header");
      $(".top_header_social").insertAfter(".top_header_info");

      $("body").hasClass("front_page")
        ? //home
        $("#nav_area").insertAfter("#header")
        : //non home
        null;
    }
  }

  swap_this();

  // Reset all configs when width > 800
  $(window).resize(function () {
    window_width = $(this).width();

    swap_this();

    if (window_width > 800) {
      $(".nav_toggle_button").removeClass("active");
      $(".hamburger").removeClass("is-active");
      primary_menu.removeClass("toggle_right_style");
      $(".toggle_right_nav").removeClass("toggle_right_cont");
      $("body").removeClass("active");
    } else {
      secondary_menu.removeAttr("style");
      toggle_secondary_button
        .children()
        .removeClass("fa-caret-up")
        .addClass("fa-caret-down");
    }
  });

  $(".rslides").responsiveSlides({
     nav: true,
     navText: ["<",">"]
  });

 $('.rslides_nav:contains("Previous")').text('❮').addClass("rslides_nav_prev");
 $('.rslides_nav:contains("Next")').text('❯').addClass("rslides_nav_next");

  $(".back_top").click(function () {
    // back to top
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      900
    );
    return false;
  });

  const stickToTop = function (targetElement, customClass) {
    if (!$("body").hasClass("front_page")) return;
    targetElement = $(targetElement);
    let targetElementDistanceFromTop = 58;
    if (targetElement.length <= 0 || $(window).width() <= 1024) {
      return;
    }

    if ($(window).scrollTop() >= targetElementDistanceFromTop) {
      targetElement.addClass(customClass);
    } else {
      targetElement.removeClass(customClass);
    }
  };

  stickToTop("#header", "fixed");

  $(window).scroll(function () {
    // fade in fade out button
    let windowScroll = $(this).scrollTop();

    if (windowScroll > webHeight * 0.5 && window_width <= 600) {
      $(".back_top").fadeIn();
    } else {
      $(".back_top").fadeOut();
    }

    stickToTop("#header", "fixed");

    // For (AddThis) Plugins
    if ($("body #at-share-dock").hasClass("at-share-dock")) {
      $(".back_top").addClass("withAddThis_plugins");
      $(".footer_btm").addClass("withAddThis_ftr_btm");
    } else {
      $(".back_top").removeClass("withAddThis_plugins");
      $(".footer_btm").removeClass("withAddThis_ftr_btm");
    }
    // End (AddThis) Plugins
  });

  // Testimonial
  $("#commentform").click(function () {
    if ($("#author").val() == "") {
      $("#author").addClass("testimonialreq");
    } else {
      $("#author").removeClass("testimonialreq");
    }

    if ($("#email").val() == "") {
      $("#email").addClass("testimonialreq");
    } else {
      $("#email").removeClass("testimonialreq");
    }

    if ($("#comment").val() == "") {
      $("#comment").addClass("testimonialreq");
    } else {
      $("#comment").removeClass("testimonialreq");
    }
  });

  // skitter
  $('.box_skitter_large').skitter({
    theme: 'minimalist',
    numbers_align: 'center',
    progressbar: false,
    navigation: true,
    numbers: false,
    dots: false,
    navigationText: [">", "<"],
    navText: [">", "<"],
    preview: false,
    interval: 4000
  });


  new WOW().init();

  // $(".owl-carousel").owlCarousel({
  //   items: 3,
  //   nav: true,
  //   dots: false,
  //   loop: true,
  //   margin:10,
  //   responsive : {
  //   291 : {
  //     items:1
  //   },
  //   751 : {
  //     items:2
  //   },
  //   1011 : {
  //     items:3
  //   }
  // }
  // });

  //---------------------- START OF CODE (FORM ACTIVATION) -------------------------------//
  $("#submit_formmessage .form_email").change(function () {
    validateEmail();
  });
  $("#submit_formmessage .form_btn").on("click", function () {
    if ($("#submit_formmessage .form_fullname").val() == "") {
      $("#submit_formmessage .form_fullname").addClass("FormReq");
    } else {
      $("#submit_formmessage .form_fullname").removeClass("FormReq");
    }
    if ($("#submit_formmessage .form_chkbox").not(":checked")) {
      $("#submit_formmessage .form_chkbox").addClass("FormReq");
    } else {
      $("#submit_formmessage .form_chkbox").removeClass("FormReq");
    }
    if ($("#submit_formmessage .form_email").val() == "") {
      $("#submit_formmessage .form_email").addClass("FormReq");
    } else {
      validateEmail();
    }
    if (grecaptcha.getResponse() == "") {
      var $recaptcha = document.querySelector("#g-recaptcha-response");
      $recaptcha.setAttribute("required", "required");
      $(".g-recaptcha iframe").addClass("FormReq").attr("id", "recaptcha");
    }
  });

  // FOR EMAIL VALIDATOR
  function validateEmail() {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var email = $("#submit_formmessage .form_email").val();
    if (!emailReg.test(email)) {
      $("#submit_formmessage .form_email").addClass("FormReq");
      $("#invalid-msg").show();
      $("#invalid-msg").html(
        "<span> Please enter a valid email address.</span>"
      );
    } else {
      $("#submit_formmessage .form_email").removeClass("FormReq");
      $("#invalid-msg").hide();
    }
  }

  // FOR PROMPT POP-UP MESSAGE
  $("#success .close").click(function () {
    $("#success").fadeOut();
    $("#recaptcha-error").fadeOut();
  });

  $(".rclose").click(function () {
    $("#recaptcha-error").fadeOut();
  });

  $("#error-msg .error-close").click(function () {
    $("#error-msg").fadeOut();
  });

  //---------------------- END OF CODE (FORM ACTIVATION -------------------------------//

  $(document).ready(function () {
    var cards = $(".collection-item");
    var numCards = cards.length;
    var numPerPage = 10;
    var numPages = Math.ceil(numCards / numPerPage);
    var currentPage = 1;

    // Initialize pagination
    $(".pagination").append('<li class="prev" data-page="prev">Previous</li>');
    for (var i = 1; i <= numPages; i++) {
      $(".pagination").append(`<li class="page-link" data-page="${i}">${i}</li>`);
    }
    $(".pagination").append('<li class="next" data-page="next">Next</li>');

    showPage(currentPage); // Show the first page by default

    // Click event for pagination
    $(".pagination").on("click", "li", function () {
      var pageNum = $(this).attr("data-page");
      if (pageNum === "prev") {
        if (currentPage > 1) {
          currentPage--;
        }
      } else if (pageNum === "next") {
        if (numPages > currentPage) {
          currentPage++;
        }
      } else {
        currentPage = parseInt(pageNum);
      }
      showPage(currentPage);
    });

    // Function to show page based on page number
    function showPage(pageNum) {
      var start = (pageNum - 1) * numPerPage;
      var end = start + numPerPage;
      cards.hide().slice(start, end).show();
      // Remove active class from all pagination buttons
      $(".pagination li").removeClass("active");
      // Add active class to the current pagination button
      $(".pagination li[data-page=" + pageNum + "]").addClass("active");
      // Disable previous/next buttons when at the start/end
      $(".prev").toggleClass("disabled", pageNum === 1);
      $(".next").toggleClass("disabled", pageNum === numPages);
    }
  });
  


  // $(document).ready(function () {
  //   var cards = $(".collection-item");
  //   var numCards = cards.length;
  //   var numPerPage = 5;
  //   var numPages = Math.ceil(numCards / numPerPage);

  //   // Initialize pagination
  //   for (var i = 1; i <= numPages; i++) {
  //     $(".pagination").append(`<li class="page-link" data-page="${i}">${i}</li>`);
  //   }

  //   showPage(1); // Show the first page by default

  //   // Click event for pagination
  //   $(".pagination").on("click", "li", function () {
  //     var pageNum = $(this).attr("data-page");
  //     showPage(pageNum);
  //   });

  //   // Function to show page based on page number
  //   function showPage(pageNum) {
  //     var start = (pageNum - 1) * numPerPage;
  //     var end = start + numPerPage;
  //     cards.hide().slice(start, end).show();
  //     $(".pagination li").removeClass("active");
  //     $(".pagination li[data-page=" + pageNum + "]").addClass("active");
  //   }
  // });
  		$('.faq h6').click(function(){
   $(this).next().slideToggle()
  .siblings('.faq div').slideUp();
  //toggle sign
   $(this).toggleClass('sign')
   .siblings('.faq h6').removeClass();
 });

		
});
